import {
  Clock,
  CheckCircle,
  Send,
  MessageCircle,
  AlertTriangle,
  LucideIcon,
} from 'lucide-react'
import { cn } from '@/lib/utils'
import type { OutreachStatus } from '@/services/api'

interface StatusConfig {
  label: string
  color: string
  darkColor: string
  icon: LucideIcon
}

export const OUTREACH_STATUS_CONFIG: Record<OutreachStatus, StatusConfig> = {
  pending: {
    label: 'Pending',
    color: 'bg-muted text-muted-foreground border-border',
    darkColor: '',
    icon: Clock,
  },
  ready: {
    label: 'Ready',
    color: 'bg-primary/10 text-primary border-primary/20',
    darkColor: '',
    icon: CheckCircle,
  },
  sent: {
    label: 'Sent',
    color: 'bg-chart-1/10 text-chart-1 border-chart-1/20',
    darkColor: '',
    icon: Send,
  },
  replied: {
    label: 'Replied',
    color: 'bg-chart-2/10 text-chart-2 border-chart-2/20',
    darkColor: '',
    icon: MessageCircle,
  },
  bounced: {
    label: 'Bounced',
    color: 'bg-destructive/10 text-destructive border-destructive/20',
    darkColor: '',
    icon: AlertTriangle,
  },
}

interface OutreachStatusBadgeProps {
  status: OutreachStatus
  showIcon?: boolean
  size?: 'sm' | 'md'
  className?: string
}

export function OutreachStatusBadge({
  status,
  showIcon = true,
  size = 'md',
  className,
}: OutreachStatusBadgeProps) {
  const config = OUTREACH_STATUS_CONFIG[status]
  const Icon = config.icon

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-md border font-medium',
        config.color,
        config.darkColor,
        size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-2.5 py-1 text-xs',
        className
      )}
    >
      {showIcon && (
        <Icon className={cn(size === 'sm' ? 'h-3 w-3' : 'h-3.5 w-3.5')} />
      )}
      {config.label}
    </span>
  )
}
